import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

const mode = 'data-tooltip-mode';
const size = 'data-tooltip-size';

export const flowTooltip: Components<Theme>['MuiTooltip'] = {
  defaultProps: {
    placement: 'bottom',
    arrow: true,
  },
  styleOverrides: {
    tooltip: ({ theme, ownerState }) => ({
      boxShadow: theme.flowShadows.xs,
      background: theme.palette.text.primary,
      color: theme.palette.background.primary,
      ...(ownerState[mode] === 'reverse' && {
        background: theme.palette.background.primary,
        color: theme.palette.text.primary,
      }),
      ...(ownerState[mode] === 'dark' && {
        background: theme.palette.onSurface.os0,
        color: theme.palette.onSurface.os900,
      }),
      ...(ownerState[mode] === 'light' && {
        background: theme.palette.onSurface.os900,
        color: theme.palette.onSurface.os0,
      }),
      // size variants
      ...(ownerState[size] === 'large'
        ? {
            ...theme.typography.body,
            maxWidth: '520px',
            borderRadius: '8px',
            padding: '24px',
            '& .FlowTooltip-header': {
              // Tooltip Large is default style for TooltipHeader
            },
            '&.MuiTooltip-tooltipArrow': {
              '&.MuiTooltip-tooltipPlacementLeft': {
                marginRight: '26px',
              },
              '&.MuiTooltip-tooltipPlacementRight': {
                marginLeft: '26px',
              },
              '&.MuiTooltip-tooltipPlacementTop': {
                marginBottom: '26px',
              },
              '&.MuiTooltip-tooltipPlacementBottom': {
                marginTop: '26px',
              },
            },
          }
        : {
            padding: '8px 12px',
            borderRadius: '2px',
            maxWidth: '200px',
            fontSize: '12px',
            fontWeight: '400',
            lineHeight: '16px',
            '& .FlowTooltip-header': {
              marginTop: '-8px',
              marginBottom: '4px',
              marginLeft: '-12px',
              marginRight: '-12px',
              padding: '8px',
            },
          }),
    }),
    arrow: ({ theme, ownerState }) => ({
      '&::before': {
        boxShadow: theme.flowShadows.xs,
        background: theme.palette.text.primary,
        ...(ownerState[mode] === 'reverse' && {
          background: theme.palette.background.primary,
        }),
        ...(ownerState[mode] === 'dark' && {
          background: theme.palette.onSurface.os0,
        }),
        ...(ownerState[mode] === 'light' && {
          background: theme.palette.onSurface.os900,
        }),
      },
      ...(ownerState[size] === 'large' && {
        // make arrow larger (size & position are in "em" unit)
        fontSize: '39px',
      }),
    }),
  },
};
